import axios from '@/api/axios'
import { buildQuery } from '@/helpers/build-query.utils'

export default {
    getEmployees: (params) => {
        const query = buildQuery(params)
        return axios.get(`/base/api/report/employees?${query}`).then((r) => r.data)
    },
    getEmployeesPdf: (params) => {
        const query = buildQuery(params)
        return axios
            .get(`/base/api/report/employees/pdf?${query}`)
            .then((res) => res.data)
    },
    getPayments: (params) => {
        const query = buildQuery(params)
        return axios.get(`/base/api/report/payments?${query}`).then((r) => r.data)
    },
    getPaymentsPdf: (params) => {
        const query = buildQuery(params)
        return axios
            .get(`/base/api/report/payments/pdf?${query}`)
            .then((res) => res.data)
    }
}
